import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import { TimePeriodAggregationType } from '../constants/time-period-aggregation-type';
import { QUARTER_LABELS } from '../constants/quarter-labels';
import { MONTH_ABBREVIATIONS } from '../constants/month-name-abbreviations';
import { WeekColumnNamePipe } from './week-column-name';

@Pipe({ name: 'timePeriodLabel' })
@Injectable({ providedIn: 'root' })
export class TimePeriodLabelPipe implements PipeTransform {
    private weekColumnNamePipe = inject(WeekColumnNamePipe);

    transform(obj: any, timePeriodAggregationType: any): string {
        if (!obj) return '';

        switch (timePeriodAggregationType) {
            case TimePeriodAggregationType.Monthly:
                return `${MONTH_ABBREVIATIONS[obj.month]} ${obj.year % 100}`;

            case TimePeriodAggregationType.Quarterly:
                return `${QUARTER_LABELS[obj.quarter]} ${obj.year % 100}`;

            case TimePeriodAggregationType.Weekly:
                return this.weekColumnNamePipe.transform(obj);

            case TimePeriodAggregationType.Yearly:
            default:
                return `${obj.year}`;
        }
    }
}
